// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38LiF","index":"styles_index__oIwPL"};